import { render } from "./ReplatformSlider.vue?vue&type=template&id=92bd0058"
import script from "./ReplatformSlider.vue?vue&type=script&lang=js"
export * from "./ReplatformSlider.vue?vue&type=script&lang=js"

import "./ReplatformSlider.vue?vue&type=style&index=0&id=92bd0058&lang=css"
script.render = render

export default script